import React from 'react';
import {Button} from "reactstrap";

//props -> data, page, setPage, last
// props.data is the data returned from API
// props.page is the current page
// props.setPage is the useState function to set page state
// props.last is the last page

function Paginator(props) {
    const totalPages = props.last;

    if (totalPages <= 1) {
        return null;
    }
    return (
        <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
                {props.page !== 1 && (
                    <li className="page-item">
                        <Button onClick={() => props.setPage(1)} className="page-link" tabIndex="-1" disabled={props.loading}>First</Button>
                    </li>
                )}
                {props.data.previous && (
                    <li className="page-item">
                        <Button onClick={() => props.setPage(old => Math.max(old - 1, 1))} className="page-link" tabIndex="-1" disabled={props.loading}><i className="fa fa-caret-left"/>  Previous</Button>
                    </li>
                )}

                {props.data.previous && props.page > 2 && (
                    <li className="page-item"><Button onClick={() => props.setPage(props.page - 2)} className="page-link" disabled={props.loading}>{props.page - 2}</Button></li>
                )}
                {props.data.previous && (
                    <li className="page-item"><Button onClick={() => props.setPage(props.page - 1)} className="page-link" disabled={props.loading}>{props.page - 1}</Button></li>
                )}

                <li className="page-item active"><Button className="page-link" disabled={props.loading}>{props.page}</Button></li>

                {props.data.next && (
                    <li className="page-item"><Button onClick={() => props.setPage(props.page + 1)} className="page-link" disabled={props.loading}>{props.page + 1}</Button></li>
                )}
                {props.data.next && props.page < props.last - 1 && (
                    <li className="page-item"><Button onClick={() => props.setPage(props.page + 2)} className="page-link" disabled={props.loading}>{props.page + 2}</Button></li>
                )}

                {props.data.next && (
                    <li className="page-item">
                        <Button onClick={() => props.setPage(old => old + 1)} className="page-link" disabled={props.loading}>Next  <i className="fa fa-caret-right"/></Button>
                    </li>
                )}
                {props.data.next && (
                    <li className="page-item">
                        <Button onClick={() => props.setPage(props.last)} className="page-link" disabled={props.loading}>Last</Button>
                    </li>
                )}
            </ul>
        </nav>
    );
}

export default Paginator;